(function () {
  'use strict';

  var addonCache = Object.create(null);
  var enhancementTimer = 0;

  var ADDONS = {
    'softlight-powder-foundation': ['all-over-powder-brush', 'essential-sponge-set'],
    'softlight-setting-powder': ['all-over-powder-brush', 'essential-sponge-set'],
    'color-correcting-powders': ['all-over-powder-brush', 'essential-sponge-set'],
    'brightening-base': ['softlight-powder-foundation', 'brightening-cleanser'],
    'brightening-cleanser': ['brightening-base', 'essential-sponge-set'],
    'blush-crush': ['setting-powder-brush', 'on-the-go-mirror'],
    'sparkling-face-shimmer': ['setting-powder-brush', 'on-the-go-mirror'],
    'icon-blurred-matte-lipstick': ['on-the-go-mirror', 'twinkle-luxe-makeup-bag'],
    'velvet-reign-matte-liquid-lipstick': ['on-the-go-mirror', 'twinkle-luxe-makeup-bag'],
    'wonder-glass-makeup-setting-spray': ['essential-sponge-set', 'makeup-brush-cleaner'],
    'angel-eyes-primer': ['eyeshadow-blender-brush', 'eyeshadow-packer-brush'],
    'brow-luxe-tool-kit': ['dual-ended-angled-brow-brush-spoolie', 'on-the-go-mirror']
  };

  var FALLBACKS = [
    'essential-sponge-set',
    'on-the-go-mirror',
    'makeup-brush-cleaner',
    'twinkle-luxe-makeup-bag',
    'all-over-powder-brush',
    'setting-powder-brush',
    'foundation-brush',
    'soft-angle-contour-brush',
    'eyeshadow-blender-brush',
    'eyeshadow-packer-brush'
  ];

  var BLOCKED_RECOMMENDATION_TERMS = /lip[\s-]*liner|hydracolor|clearance/i;

  function isProductPage() {
    return document.body && document.body.classList.contains('product-page');
  }

  function productHandle() {
    var parts = window.location.pathname.split('/').filter(Boolean);
    var index = parts.indexOf('products');
    return index >= 0 ? parts[index + 1] || '' : '';
  }

  function formatMoney(value) {
    var amount = Number(value || 0);
    if (amount > 9999) amount = amount / 100;
    return 'Rs.' + Math.round(amount).toLocaleString('en-US');
  }

  function parseVariants(root) {
    var node = root.querySelector('[data-luscious-variants]');
    if (!node) return [];
    try {
      var variants = JSON.parse(node.textContent || '[]');
      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      return [];
    }
  }

  function selectedOptions(root) {
    var options = [];
    root.querySelectorAll('[data-luscious-option-position]').forEach(function (fieldset) {
      var index = Number(fieldset.getAttribute('data-luscious-option-position')) - 1;
      var checked = fieldset.querySelector('[data-luscious-option-input]:checked');
      if (checked) options[index] = checked.value;
    });
    return options;
  }

  function variantOptions(variant) {
    return [variant.option1, variant.option2, variant.option3].filter(function (value) {
      return value !== null && value !== undefined && value !== '';
    });
  }

  function normalizeMediaKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function variantMediaIds(variant) {
    var ids = [];
    if (!variant) return ids;
    if (variant.featured_media && variant.featured_media.id) ids.push(String(variant.featured_media.id));
    if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.id) ids.push(String(variant.featured_media.preview_image.id));
    if (variant.featured_image && variant.featured_image.id) ids.push(String(variant.featured_image.id));
    if (Array.isArray(variant.media)) {
      variant.media.forEach(function (media) {
        if (media && media.id) ids.push(String(media.id));
      });
    }
    return ids.filter(function (id, index) { return id && ids.indexOf(id) === index; });
  }

  function optionKeysForVariant(variant) {
    return variantOptions(variant).map(normalizeMediaKey).filter(Boolean);
  }

  function mediaText(element) {
    var image = element.querySelector('img, video');
    return [
      element.getAttribute('aria-label'),
      image && image.getAttribute('alt'),
      image && image.currentSrc,
      image && image.src,
      image && image.getAttribute('poster')
    ].join(' ');
  }

  function assignMediaGroups(root, variants) {
    if (!root || root.dataset.lusciousMediaGrouped === 'true') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-luscious-media-id]'));
    var elements = Array.prototype.slice.call(root.querySelectorAll('[data-luscious-media-id], [data-luscious-media-trigger]'));
    if (!elements.length || !variants.length) return;

    var optionKeys = [];
    variants.forEach(function (variant) {
      optionKeysForVariant(variant).forEach(function (key) {
        if (key && optionKeys.indexOf(key) === -1) optionKeys.push(key);
      });
    });
    if (!optionKeys.length) return;

    var idsByKey = Object.create(null);
    variants.forEach(function (variant) {
      var keys = optionKeysForVariant(variant);
      variantMediaIds(variant).forEach(function (id) {
        keys.forEach(function (key) { idsByKey[id] = key; });
      });
    });

    var groupByMediaId = Object.create(null);
    slides.forEach(function (slide) {
      var mediaId = slide.getAttribute('data-luscious-media-id');
      var group = mediaId && idsByKey[mediaId];
      var text = normalizeMediaKey(mediaText(slide));
      if (!group && text) {
        group = optionKeys.filter(function (key) {
          return key && text.indexOf(key) >= 0;
        })[0] || '';
      }
      if (mediaId && group) groupByMediaId[mediaId] = group;
    });

    var run = [];
    function assignRun() {
      var keyCount = optionKeys.length;
      if (run.length >= keyCount && run.length % keyCount === 0) {
        run.forEach(function (mediaId, index) {
          groupByMediaId[mediaId] = optionKeys[index % keyCount];
        });
      }
      run = [];
    }

    slides.forEach(function (slide) {
      var mediaId = slide.getAttribute('data-luscious-media-id');
      if (!mediaId) return;
      if (groupByMediaId[mediaId]) {
        assignRun();
      } else {
        run.push(mediaId);
      }
    });
    assignRun();

    elements.forEach(function (element) {
      var mediaId = element.getAttribute('data-luscious-media-id') || element.getAttribute('data-luscious-media-trigger');
      var group = mediaId && groupByMediaId[mediaId];
      if (group) element.dataset.lusciousMediaGroup = group;
    });

    root.dataset.lusciousMediaGrouped = 'true';
  }

  function filterGalleryForVariant(root, variant, variants) {
    if (!root || !variant) return;
    assignMediaGroups(root, variants || []);

    var keys = optionKeysForVariant(variant);
    if (!keys.length) return;
    var grouped = Array.prototype.slice.call(root.querySelectorAll('[data-luscious-media-group]'));
    if (!grouped.length) return;
    var targetKey = keys.filter(function (key) {
      return grouped.some(function (element) { return element.dataset.lusciousMediaGroup === key; });
    })[0];
    if (!targetKey) return;

    var visibleIds = [];
    Array.prototype.slice.call(root.querySelectorAll('[data-luscious-media-id], [data-luscious-media-trigger]')).forEach(function (element) {
      var group = element.dataset.lusciousMediaGroup;
      var visible = !group || group === targetKey;
      element.hidden = !visible;
      element.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (!visible) element.classList.remove('is-active');
      var mediaId = element.getAttribute('data-luscious-media-id') || element.getAttribute('data-luscious-media-trigger');
      if (visible && mediaId && visibleIds.indexOf(mediaId) === -1) visibleIds.push(mediaId);
    });

    var preferredId = variantMediaIds(variant).filter(function (id) { return visibleIds.indexOf(id) >= 0; })[0] || visibleIds[0];
    if (preferredId) setActiveMedia(root, preferredId);
  }

  function findVariant(variants, options) {
    if (!variants.length) return null;
    if (!options.length) {
      return variants.filter(function (variant) { return variant.available !== false; })[0] || variants[0];
    }
    return variants.filter(function (variant) {
      var current = variantOptions(variant);
      return options.every(function (value, index) { return current[index] === value; });
    })[0] || null;
  }

  function mediaIdFromVariant(variant) {
    return variantMediaIds(variant)[0] || '';
  }

  function setActiveMedia(root, mediaId) {
    if (!mediaId) return;
    var slides = root.querySelectorAll('[data-luscious-media-id]');
    var triggers = root.querySelectorAll('[data-luscious-media-trigger]');
    var matched = false;

    slides.forEach(function (slide) {
      var active = slide.getAttribute('data-luscious-media-id') === String(mediaId);
      slide.classList.toggle('is-active', active);
      if (active) matched = true;
      slide.querySelectorAll('video').forEach(function (video) {
        if (active) {
          video.muted = true;
          video.playsInline = true;
          var play = video.play && video.play();
          if (play && play.catch) play.catch(function () {});
        } else if (video.pause) {
          video.pause();
        }
      });
    });

    if (!matched) return;
    triggers.forEach(function (trigger) {
      var active = trigger.getAttribute('data-luscious-media-trigger') === String(mediaId);
      trigger.classList.toggle('is-active', active);
      trigger.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function setPrice(root, variant) {
    var price = root.querySelector('.luscious-pdp__price-current');
    var compare = root.querySelector('.luscious-pdp__price-compare');
    if (!variant || !price) return;
    price.textContent = formatMoney(variant.price);
    if (!compare) return;
    if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
      compare.hidden = false;
      compare.textContent = formatMoney(variant.compare_at_price);
    } else {
      compare.hidden = true;
      compare.textContent = '';
    }
  }

  function syncFormVariantId(root, input, variantId) {
    var form = root && root.querySelector('.luscious-pdp__form');
    if (!form || !variantId) return;
    var submitInput = form.querySelector('[data-luscious-submit-variant-id]');
    if (!submitInput) {
      submitInput = document.createElement('input');
      submitInput.setAttribute('data-luscious-submit-variant-id', '');
      submitInput.setAttribute('aria-hidden', 'true');
      submitInput.tabIndex = -1;
      submitInput.style.display = 'none';
      if (input && input.parentNode) input.parentNode.insertBefore(submitInput, input.nextSibling);
      else form.insertBefore(submitInput, form.firstChild);
    }
    submitInput.type = 'text';
    submitInput.name = 'id';
    submitInput.disabled = false;
    submitInput.setAttribute('aria-hidden', 'true');
    submitInput.tabIndex = -1;
    submitInput.style.display = 'none';
    submitInput.value = variantId;
    submitInput.defaultValue = variantId;
    submitInput.setAttribute('value', variantId);
    submitInput.dataset.variantId = variantId;
    if (input && input !== submitInput) {
      input.disabled = true;
      input.removeAttribute('name');
      input.dataset.variantId = variantId;
    }
    root.dataset.currentVariantId = variantId;
  }

  function setVariantState(root, variant) {
    var input = root.querySelector('[data-luscious-variant-id]');
    var button = root.querySelector('[data-luscious-add-button]');
    var variantId = '';
    if (input) {
      variantId = variant && variant.id ? String(variant.id) : input.dataset.initialVariantId || root.getAttribute('data-initial-variant-id') || '';
      if (variantId) {
        input.value = variantId;
        input.setAttribute('value', variantId);
        input.dataset.variantId = variantId;
      }
    }
    if (variantId) syncFormVariantId(root, input, variantId);
    if (button && variant) {
      button.disabled = variant.available === false;
      button.textContent = variant.available === false ? 'Sold out' : 'Add to cart';
    }
    setPrice(root, variant);
    filterGalleryForVariant(root, variant, parseVariants(root));
    setActiveMedia(root, mediaIdFromVariant(variant));
  }

  function initGallery(root) {
    root.querySelectorAll('[data-luscious-media-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        setActiveMedia(root, trigger.getAttribute('data-luscious-media-trigger'));
      });
    });

    root.querySelectorAll('.luscious-pdp__slide.is-active video').forEach(function (video) {
      video.muted = true;
      video.playsInline = true;
      var play = video.play && video.play();
      if (play && play.catch) play.catch(function () {});
    });
  }

  function initVariantPicker(root) {
    var variants = parseVariants(root);
    assignMediaGroups(root, variants);
    var initial = findVariant(variants, selectedOptions(root));
    setVariantState(root, initial);

    root.querySelectorAll('[data-luscious-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var fieldset = input.closest('[data-luscious-option-position]');
        if (fieldset) {
          fieldset.querySelectorAll('.luscious-pdp__swatch').forEach(function (swatch) {
            swatch.classList.toggle('is-selected', swatch.contains(input));
          });
          var label = root.querySelector('[data-luscious-selected-option="' + fieldset.getAttribute('data-luscious-option-position') + '"]');
          if (label) label.textContent = input.value;
        }
        setVariantState(root, findVariant(variants, selectedOptions(root)));
      });
    });
  }

  function initQuantity(root) {
    var input = root.querySelector('[data-luscious-quantity]');
    if (!input) return;
    var minus = root.querySelector('[data-luscious-qty-minus]');
    var plus = root.querySelector('[data-luscious-qty-plus]');
    function value() { return Math.max(1, parseInt(input.value, 10) || 1); }
    if (minus) minus.addEventListener('click', function () { input.value = String(Math.max(1, value() - 1)); });
    if (plus) plus.addEventListener('click', function () { input.value = String(value() + 1); });
    input.addEventListener('change', function () { input.value = String(value()); });
  }

  function initForm(root) {
    var form = root.querySelector('.luscious-pdp__form');
    if (!form) return;
    
    // Clean form submit logic using Fetch API identical to the working add-on drawer logic
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var input = root.querySelector('[data-luscious-variant-id]');
      var variant = findVariant(parseVariants(root), selectedOptions(root));
      if (input) {
        var variantId = variant && variant.id ? String(variant.id) : input.dataset.variantId || input.dataset.initialVariantId || root.getAttribute('data-initial-variant-id') || '';
        if (variantId) {
          input.value = variantId;
          input.setAttribute('value', variantId);
          input.dataset.variantId = variantId;
        }
      }
      if (variantId) syncFormVariantId(root, input, variantId);

      var activeVariantId = input ? (input.value || input.dataset.variantId) : '';
      if (!activeVariantId) return;

      var button = form.querySelector('[data-luscious-add-button], button[type="submit"]');
      var original = button ? button.textContent : 'Add to cart';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      var rootPath = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var hdrEl = document.querySelector('[id^="shopify-section-"][id$="__header_section"]');
      var sectionId = hdrEl ? hdrEl.id.replace('shopify-section-', '') : '';

      var mainItem = { id: parseInt(activeVariantId, 10), quantity: parseInt(root.querySelector('[data-luscious-quantity]') ? root.querySelector('[data-luscious-quantity]').value : 1, 10) || 1 };
      var routineSelector = document.querySelector('routine-selector[data-main-product-id="' + root.getAttribute('data-product-handle') + '"]');
      // The selector above uses product handle on older markup; current markup is keyed by product id,
      // so fall back to the routine selector inside this PDP details area.
      routineSelector = root.querySelector('routine-selector') || document.querySelector('routine-selector[data-main-product-id]') || routineSelector;
      var routineItems = routineSelector && typeof routineSelector.selectedItems === 'function' ? routineSelector.selectedItems() : [];
      var merged = {};
      [mainItem].concat(routineItems).forEach(function(item){
        if (!item || !item.id || !item.quantity) return;
        var key = String(item.id);
        merged[key] = (merged[key] || 0) + Number(item.quantity);
      });
      var fetchBody = {
        items: Object.keys(merged).map(function(id){ return { id: parseInt(id, 10), quantity: merged[id] }; })
      };
      if (sectionId) {
        fetchBody.sections = sectionId;
      }

      fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(fetchBody)
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function(err) {
            throw new Error(err.description || err.message || 'Add to cart failed');
          });
        }
        return response.json();
      })
      .then(function (payload) {
        // Handle dynamic section drawer markup swap if returned
        var cartRoot = document.getElementById('llc-cart-root');
        if (cartRoot && payload.sections && sectionId && payload.sections[sectionId]) {
          try {
            var doc = new DOMParser().parseFromString(payload.sections[sectionId], 'text/html');
            var fresh = doc.querySelector('[data-llc-body]');
            var cur = cartRoot.querySelector('[data-llc-body]');
            if (fresh && cur) {
              cur.innerHTML = fresh.innerHTML;
            }
          } catch(err) {}
        }

        if (routineSelector && routineItems.length && typeof routineSelector.clearRoutineSelection === 'function') {
          routineSelector.clearRoutineSelection();
        }
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: payload } }));
        document.body.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: payload } }));
        
        if (button) button.textContent = 'Added';

        // Automatically open the cart drawer if available
        if (cartRoot && typeof cartRoot.open === 'function') {
          cartRoot.open();
        }
      })
      .catch(function (error) {
        console.error('PDP Cart Error:', error);
        if (button) button.textContent = 'Error';
        alert(error.message || 'There was an error adding this item to your cart.');
      })
      .finally(function () {
        window.setTimeout(function () {
          if (!button) return;
          button.disabled = false;
          button.textContent = original;
        }, 1200);
      });
    });
  }

  function productAllowed(product) {
    var text = [product && product.title, product && product.handle, product && product.product_type, product && product.tags].join(' ');
    return !BLOCKED_RECOMMENDATION_TERMS.test(text);
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!addonCache[handle]) {
      addonCache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    }
    return addonCache[handle];
  }

  function firstSingleAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants) || product.variants.length !== 1) return null;
    var variant = product.variants[0];
    return variant && variant.available !== false ? variant : null;
  }

  function productImage(product) {
    if (product && product.featured_image) return product.featured_image;
    if (product && Array.isArray(product.images) && product.images.length) return product.images[0];
    return '';
  }

  function saleNumbers(product) {
    return {
      price: Number(product.price_min || product.price || 0),
      compare: Number(product.compare_at_price_max || product.compare_at_price || 0)
    };
  }

  function renderAddon(product) {
    var variant = firstSingleAvailableVariant(product);
    if (!variant) return null;
    var sale = saleNumbers(product);
    var item = document.createElement('article');
    item.className = 'luscious-pdp-addons__item';

    var imageUrl = productImage(product);
    item.innerHTML =
      '<a class="luscious-pdp-addons__media" href="' + (product.url || '/products/' + product.handle) + '">' +
        (imageUrl ? '<img src="' + imageUrl + (imageUrl.indexOf('?') === -1 ? '?width=180' : '') + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="luscious-pdp-addons__info">' +
        '<a class="luscious-pdp-addons__title" href="' + (product.url || '/products/' + product.handle) + '">' + (product.title || '') + '</a>' +
        '<div class="luscious-pdp-addons__prices"><span class="luscious-pdp-addons__price">' + formatMoney(sale.price || variant.price) + '</span>' +
          (sale.compare && sale.compare > sale.price ? '<s>' + formatMoney(sale.compare) + '</s>' : '') +
        '</div>' +
      '</div>' +
      '<form class="luscious-pdp-addons__form" method="post" action="/cart/add" data-variant-id="' + variant.id + '">' +
        '<input type="hidden" name="id" value="' + variant.id + '" data-luscious-addon-id>' +
        '<input type="hidden" name="quantity" value="1" data-luscious-addon-quantity>' +
        '<button type="submit" data-variant-id="' + variant.id + '">+ Add</button>' +
      '</form>';
    var idInput = item.querySelector('[data-luscious-addon-id]');
    var quantityInput = item.querySelector('[data-luscious-addon-quantity]');
    if (idInput) {
      idInput.value = String(variant.id);
      idInput.setAttribute('value', String(variant.id));
    }
    if (quantityInput) {
      quantityInput.value = '1';
      quantityInput.setAttribute('value', '1');
    }
    return item;
  }

  function initAddons(scope) {
    if (!isProductPage()) return;
    var root = (scope || document).querySelector('[data-luscious-pdp]');
    var mount = root && root.querySelector('[data-luscious-pdp-addons]');
    if (!root || !mount || mount.dataset.lusciousReady === 'true') return;
    mount.dataset.lusciousReady = 'true';

    var current = productHandle();
    var handles = (ADDONS[current] || FALLBACKS).filter(function (handle) { return handle !== current; });
    var grid = mount.querySelector('.luscious-pdp-addons__items');
    if (!grid) return;

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      grid.innerHTML = '';
      products.filter(function (product) {
        return product && product.handle !== current && product.available !== false && productAllowed(product) && firstSingleAvailableVariant(product);
      }).slice(0, 2).forEach(function (product) {
        var item = renderAddon(product);
        if (item) grid.appendChild(item);
      });
      mount.hidden = !grid.children.length;
    });
  }

  function reviewCards(widget) {
    return Array.prototype.slice.call(widget.querySelectorAll('.jdgm-rev')).filter(function (card) {
      return !card.closest('.jdgm-rev-widg__summary');
    });
  }

  function showReviews(widget) {
    var visible = Number(widget.dataset.lusciousVisibleReviews || 4);
    var cards = reviewCards(widget);
    cards.forEach(function (card, index) {
      card.classList.toggle('luscious-review-hidden', index >= visible);
    });
    var loadMore = widget.querySelector('.jdgm-paginate__load-more, .jdgm-paginate a, .jdgm-paginate button');
    if (loadMore) loadMore.hidden = visible >= cards.length;
  }

  function initReviews(scope) {
    if (!isProductPage()) return;
    (scope || document).querySelectorAll('.jdgm-rev-widg').forEach(function (widget) {
      if (!widget.dataset.lusciousVisibleReviews) widget.dataset.lusciousVisibleReviews = '4';
      showReviews(widget);
    });
  }

  function renderRecommendation(product) {
    var sale = saleNumbers(product);
    var card = document.createElement('a');
    card.className = 'luscious-you-may-like__card';
    card.href = product.url || '/products/' + product.handle;

    var imageUrl = productImage(product);
    if (imageUrl) {
      var image = document.createElement('img');
      image.className = 'luscious-you-may-like__image';
      image.src = imageUrl.indexOf('?') === -1 ? imageUrl + '?width=420' : imageUrl;
      image.alt = product.title || '';
      image.loading = 'lazy';
      card.appendChild(image);
    }

    if (sale.compare && sale.compare > sale.price) {
      var percent = Math.round(((sale.compare - sale.price) / sale.compare) * 100);
      var badge = document.createElement('span');
      badge.className = 'luscious-you-may-like__badge';
      badge.textContent = percent + '% OFF';
      card.appendChild(badge);
    }

    var name = document.createElement('span');
    name.className = 'luscious-you-may-like__name';
    name.textContent = product.title || '';
    card.appendChild(name);

    var prices = document.createElement('span');
    prices.className = 'luscious-you-may-like__prices';
    var price = document.createElement('span');
    price.className = 'luscious-you-may-like__price';
    price.textContent = formatMoney(sale.price || product.price || 0);
    prices.appendChild(price);
    if (sale.compare && sale.compare > sale.price) {
      var compare = document.createElement('s');
      compare.className = 'luscious-you-may-like__compare';
      compare.textContent = formatMoney(sale.compare);
      prices.appendChild(compare);
    }
    card.appendChild(prices);
    return card;
  }

  function initYouMayAlsoLike() {
    if (!isProductPage() || document.getElementById('luscious-you-may-like')) return;
    var productSection = document.querySelector('[data-luscious-pdp]');
    if (!productSection) return;
    var mountAfter = productSection.closest('.shopify-section') || productSection;
    var handle = productHandle();
    if (!handle) return;

    fetchProduct(handle).then(function (product) {
      if (!product || !product.id) return null;
      return fetch('/recommendations/products.json?product_id=' + product.id + '&limit=8&intent=related', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (payload) {
          var products = payload && Array.isArray(payload.products) ? payload.products : [];
          products = products.filter(function (item) {
            return item && item.handle && item.handle !== product.handle && item.available !== false && productAllowed(item);
          }).slice(0, 4);
          if (!products.length || document.getElementById('luscious-you-may-like')) return;

          var section = document.createElement('section');
          section.id = 'luscious-you-may-like';
          section.className = 'luscious-you-may-like';
          section.setAttribute('aria-label', 'You may also like');
          section.innerHTML = '<div class="luscious-you-may-like__inner"><h2 class="luscious-you-may-like__title">You may also like</h2><div class="luscious-you-may-like__grid"></div></div>';
          var grid = section.querySelector('.luscious-you-may-like__grid');
          products.forEach(function (item) { grid.appendChild(renderRecommendation(item)); });
          mountAfter.parentNode.insertBefore(section, mountAfter.nextSibling);
        });
    }).catch(function () {});
  }

  function initPdp(root) {
    if (!root || root.dataset.lusciousPdpReady === 'true') return;
    root.dataset.lusciousPdpReady = 'true';
    initGallery(root);
    initVariantPicker(root);
    initQuantity(root);
    initForm(root);
  }

  function initEnhancements(scope) {
    initAddons(scope || document);
    initReviews(scope || document);
    initYouMayAlsoLike();
  }

  function boot() {
    document.querySelectorAll('[data-luscious-pdp]').forEach(initPdp);
    initEnhancements(document);
  }

  // Event delegation for Add-on items AJAX cart submission
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.luscious-pdp-addons__form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var variantId = form.getAttribute('data-variant-id') || (form.querySelector('button') && form.querySelector('button').getAttribute('data-variant-id'));
    if (idInput && !idInput.value && variantId) {
      idInput.value = variantId;
      idInput.setAttribute('value', variantId);
    }
    if (!idInput || !idInput.value) {
      event.preventDefault();
      return;
    }
    event.preventDefault();

    var button = form.querySelector('button');
    var original = button ? button.textContent : '+ Add';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding';
    }

    var rootPath = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var hdrEl = document.querySelector('[id^="shopify-section-"][id$="__header_section"]');
    var sectionId = hdrEl ? hdrEl.id.replace('shopify-section-', '') : '';

    var formData = new FormData(form);
    var bodyData = {
      items: [{ id: parseInt(formData.get('id'), 10), quantity: parseInt(formData.get('quantity') || 1, 10) }]
    };
    if (sectionId) {
      bodyData.sections = sectionId;
    }

    fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(bodyData)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add-on add failed');
        return response.json();
      })
      .then(function (payload) {
        var cartRoot = document.getElementById('llc-cart-root');
        if (cartRoot && payload.sections && sectionId && payload.sections[sectionId]) {
          try {
            var doc = new DOMParser().parseFromString(payload.sections[sectionId], 'text/html');
            var fresh = doc.querySelector('[data-llc-body]');
            var cur = cartRoot.querySelector('[data-llc-body]');
            if (fresh && cur) {
              cur.innerHTML = fresh.innerHTML;
            }
          } catch(err) {}
        }

        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: payload } }));
        document.body.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: payload } }));
        if (button) button.textContent = 'Added';

        if (cartRoot && typeof cartRoot.open === 'function') {
          cartRoot.open();
        }
      })
      .catch(function () {
        if (button) button.textContent = 'Retry';
      })
      .finally(function () {
        window.setTimeout(function () {
          if (!button) return;
          button.disabled = false;
          button.textContent = original;
        }, 1200);
      });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('button, a, [role="button"]');
    var widget = trigger && trigger.closest('.jdgm-rev-widg');
    if (!widget) return;
    var text = (trigger.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    var isLoadMore = /load more|show more|more reviews|see more/.test(text) || String(trigger.className).indexOf('load-more') >= 0;
    if (!isLoadMore) return;

    var visible = Number(widget.dataset.lusciousVisibleReviews || 4);
    if (reviewCards(widget).some(function (_, index) { return index >= visible; })) {
      event.preventDefault();
      event.stopPropagation();
      widget.dataset.lusciousVisibleReviews = String(visible + 4);
      showReviews(widget);
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);

  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      window.clearTimeout(enhancementTimer);
      enhancementTimer = window.setTimeout(function () { initEnhancements(document); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();